import React from 'react';

const UnauthorizedHeader = () => {
  return <></>;
};

export default UnauthorizedHeader;
